import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const WarningTriangle = (props: Props): ReactElement => {
  const { width, height, style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 16"
      width={width}
      height={height}
      style={style}
      color="currentColor"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#F08A02" fillRule="nonzero">
          <g>
            <path
              d="M10.894.955L17.7 11.936c.195.316.299.678.299 1.048 0 1.106-.904 2.004-2.02 2.005L2.024 15c-.39 0-.77-.11-1.097-.32-.939-.599-1.21-1.84-.604-2.77L7.472.919c.164-.252.383-.464.64-.621.952-.58 2.197-.285 2.782.658zm-2.081.265c-.089.055-.164.128-.22.215l-7.357 11.38c-.203.315-.12.73.185.942l.022.015c.112.072.243.11.376.11l14.363-.011c.383 0 .693-.31.693-.692 0-.128-.036-.253-.103-.362L9.767 1.447c-.2-.325-.628-.426-.954-.227zm.328 10.011c.414 0 .75.334.75.746 0 .411-.336.745-.75.745-.415 0-.75-.334-.75-.745 0-.412.335-.746.75-.746zm0-7.458c.513 0 .761.483.75.826l-.164 4.553c-.012.343-.275.621-.586.621-.312 0-.575-.278-.587-.62L8.39 4.598c-.012-.343.236-.826.75-.826z"
              transform="translate(-601 -108) translate(601 108.5)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

WarningTriangle.defaultProps = {
  width: '32px',
  height: '32px',
  style: {},
};

export default WarningTriangle;
